"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDateJsonDef = void 0;
var tslib_1 = require("tslib");
var joi_1 = tslib_1.__importDefault(require("joi"));
exports.parseDateJsonDef = joi_1.default.object({
    __type: joi_1.default.string().valid('Date').required(),
    iso: joi_1.default.string().required(),
});
//# sourceMappingURL=parse.date.json.def.js.map